import { render } from "./MapaReservas.vue?vue&type=template&id=44676413&scoped=true"
import script from "./MapaReservas.vue?vue&type=script&lang=js"
export * from "./MapaReservas.vue?vue&type=script&lang=js"

import "./MapaReservas.vue?vue&type=style&index=0&id=44676413&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44676413"]])

export default __exports__